export const CardIcon = ({ className = "h-3.5 w-3.5" }) => (
  <svg viewBox="0 0 16 20" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" className={className} aria-hidden>
    <rect x="1.5" y="1.5" width="13" height="17" rx="2" />
    <rect x="4" y="4.5" width="8" height="6" rx="0.8" />
    <path d="M4 13.5h8M4 16h5" strokeLinecap="round" />
  </svg>
);
